module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/cycle_ergometer-bbf7f1a00616adbe11380e8f94474fdd.svg";